import { render, staticRenderFns } from "./FeedbackSection.vue?vue&type=template&id=fbbe9f4e&scoped=true&"
import script from "./FeedbackSection.vue?vue&type=script&lang=js&"
export * from "./FeedbackSection.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackSection.vue?vue&type=style&index=0&id=fbbe9f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbe9f4e",
  null
  
)

export default component.exports